<template>
    <main>
        <div class="autocomplete">
            <input style="background:white; color:black" placeholder="Ingrese dirección" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter(3)" v-model="searchMap" @input="searchList(3)" class="form-control J-search-map w-100">
            <ul class="autocomplete-results" v-show="isOpen3"  v-click-outside="closeOpen">
                <li class="loading" v-if="isLoading">
                    Loading results...
                </li>
                <li class="autocomplete-result" v-else v-for="(result, i) in results" :key="i" @click="setResult(result,3)" :class="{ 'active': i === arrowCounter }">
                    {{ result.label }}
                </li>
            </ul>
        </div>
    </main>
</template>
<script>
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import ClickOutside from 'vue-click-outside'

import { EventBus } from '@/helpers/eventbus/event-bus'

export default {
    data(){
        return{
            searchMap:'',
            searchMapValue:{value:'hello'},
            search:{
                descripcion:'',
            },
            items:[],
            items2:[],
            items3:[],
            provider:new OpenStreetMapProvider(),
            searchProveedorEntidad:'',
            searchProductoCat:'',

            results: [],
            arrowCounter: -1,
            isLoading:false,
            isOpen: false,
            isOpen2: false,
            isOpen3: false,
            isAsync:false,
        }
    },
    props:{
        valueSearch:{required:false,default:''},
    },
    directives: {
        ClickOutside
    },
    mounted(){
        this.searchMap="";
        var $el=this;
        EventBus.$on('mapchange',data=>{
            this.searchMap=data;
        });
        this.searchMap=this.valueSearch;
    },
    methods:{
        closeOpen:function(){
            this.isOpen3 = false;
        },
        keyChange:function(){
            this.$emit('keyChange',this.searchMap)
        },
        filter:function(item,list){
            return list.filter(function(el){
                return el.id.indexOf(item)>-1;
            });
        },
        searchList:function(num){
            this.keyChange()
            switch(num){
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    
                    if (this.isAsync) {
                        this.isLoading = true;
                    } else {
                        // Data is sync, we can search our flat array
                        this.filterResults(3);
                        this.isOpen3 = true;
                    }
                    break;

            }
        },
        setResult(result,num) {
            this.keyChange()
            switch(num){
              case 1:
               

              break;
              case 2:
                
              break;
              case 3:
               
                this.selected(result);
                var map=result.label.trim();
                this.searchMap = map;
                this.isOpen3 = false;
                

              break;
            }
          },
        filterResults(num) {
            switch(num){
                case 1:
                   
                case 2:
                    
                    break;
                case 3:
                    this.results = this.items3.filter(item => {
                        var map=item.label.replace(',','');
                        
                        return this.getCleanedString(map).indexOf(this.getCleanedString(this.searchMap)) > -1;
                    });
                    if(this.results.length==0){
                        this.listar(this.searchMap);
                    }
                break;
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter(num) {
            switch(num){
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    //this.$emit('selected',this.results[this.arrowCounter]);
                    var map=this.results[this.arrowCounter];
                    this.selected(map)
                    this.searchMap = map.label;
                    this.isOpen3 = false;
                    break;
            }
            this.arrowCounter = -1;
        },
        selected:function(data){
            //console.log(data)
            this.$emit('selected',data)
        },
        listar:async function(valor,option=0){
            const results = await this.provider.search({ query: valor });
            this.items3=results;
            this.results=this.items3;
            this.isOpen3=true;
            
        }
    }
}
</script>
